import { createSlice } from '@reduxjs/toolkit';

const updateUserNotificationConsentStateSlice = createSlice({
  name: 'updateUserNotificationConsentState',
  initialState: {
    loading: false,
    success: false,
    error: null,
    userNotificationConsentState: null, 
  },
  reducers: {
    updateUserNotificationConsentStateRequest(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    updateUserNotificationConsentStateSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.userNotificationConsentState ={...action.payload};
    },
    updateUserNotificationConsentStateFailure(state, action) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    resetUpdateUserNotificationConsentState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.userNotificationConsentState = null;
    },
  },
});

export const {
  updateUserNotificationConsentStateRequest,
  updateUserNotificationConsentStateSuccess,
  updateUserNotificationConsentStateFailure,
  resetUpdateUserNotificationConsentState
} = updateUserNotificationConsentStateSlice.actions;

export default updateUserNotificationConsentStateSlice.reducer;